export const QUIZ_T = {
  pt: {
    intro: {
      overline: "Teste de nível FLE · 100% grátis",
      title: "Descubra seu nível de francês em 5 minutos.",
      subtitle:
        "20 questões reais (A1 → C1) elaboradas pelo Professor Lionel. Ao final você recebe seu nível CEFR, as correções comentadas e os próximos passos para evoluir.",
      cta: "Começar o teste",
      back: "← Voltar para o site",
      meta: ["20 questões", "5 níveis CEFR", "Correção detalhada"],
    },
    quiz: {
      question: "Questão",
      of: "de",
      next: "Próxima",
      prev: "Anterior",
      finish: "Ver meu resultado",
      pickOne: "Escolha uma resposta para continuar",
    },
    gate: {
      overline: "Falta 1 passo",
      title: "Para ver seu resultado, deixe seu nome e e-mail.",
      subtitle:
        "Você receberá seu nível CEFR, a correção comentada e dicas personalizadas do Professor Lionel. Sem spam, prometido.",
      name: "Nome completo",
      email: "E-mail",
      submit: "Ver meu nível",
      submitting: "Enviando…",
      error: "Algo deu errado. Verifique seu e-mail e tente novamente.",
      privacy: "Usamos seu e-mail apenas para enviar conteúdos sobre francês. Sem compartilhamento.",
    },
    result: {
      overline: "Seu resultado",
      yourLevel: "Seu nível",
      score: "Acertos",
      correctionsTitle: "Correção comentada",
      correct: "Sua resposta",
      yourAnswer: "Sua resposta",
      correctAnswer: "Resposta correta",
      explanation: "Explicação",
      ctaBook: "Quero minha aula grátis com o Lionel",
      ctaRetake: "Refazer o teste",
      back: "← Voltar para o site",
    },
  },
  en: {
    intro: {
      overline: "FLE level test · 100% free",
      title: "Discover your French level in 5 minutes.",
      subtitle:
        "20 real questions (A1 → C1) crafted by Professor Lionel. At the end you receive your CEFR level, commented corrections and the next steps to grow.",
      cta: "Start the test",
      back: "← Back to the site",
      meta: ["20 questions", "5 CEFR levels", "Detailed corrections"],
    },
    quiz: {
      question: "Question",
      of: "of",
      next: "Next",
      prev: "Previous",
      finish: "See my result",
      pickOne: "Pick an answer to continue",
    },
    gate: {
      overline: "1 step away",
      title: "To see your result, leave your name and email.",
      subtitle:
        "You'll receive your CEFR level, the commented corrections and personalised tips from Professor Lionel. No spam, promise.",
      name: "Full name",
      email: "Email",
      submit: "See my level",
      submitting: "Sending…",
      error: "Something went wrong. Check your email and try again.",
      privacy: "We use your email only to share French content. No sharing with third parties.",
    },
    result: {
      overline: "Your result",
      yourLevel: "Your level",
      score: "Correct answers",
      correctionsTitle: "Commented corrections",
      correct: "Your answer",
      yourAnswer: "Your answer",
      correctAnswer: "Correct answer",
      explanation: "Explanation",
      ctaBook: "Book my free lesson with Lionel",
      ctaRetake: "Retake the test",
      back: "← Back to the site",
    },
  },
  fr: {
    intro: {
      overline: "Test de niveau FLE · 100 % offert",
      title: "Découvrez votre niveau de français en 5 minutes.",
      subtitle:
        "20 questions réelles (A1 → C1) conçues par le Professeur Lionel. À la fin, vous recevez votre niveau CECRL, les corrections commentées et vos prochaines étapes pour progresser.",
      cta: "Commencer le test",
      back: "← Retour au site",
      meta: ["20 questions", "5 niveaux CECRL", "Corrections détaillées"],
    },
    quiz: {
      question: "Question",
      of: "sur",
      next: "Suivant",
      prev: "Précédent",
      finish: "Voir mon résultat",
      pickOne: "Choisissez une réponse pour continuer",
    },
    gate: {
      overline: "Plus qu'une étape",
      title: "Pour voir votre résultat, laissez votre nom et e-mail.",
      subtitle:
        "Vous recevrez votre niveau CECRL, les corrections commentées et des conseils personnalisés du Professeur Lionel. Pas de spam, promis.",
      name: "Nom complet",
      email: "E-mail",
      submit: "Voir mon niveau",
      submitting: "Envoi…",
      error: "Une erreur est survenue. Vérifiez votre e-mail et réessayez.",
      privacy: "Nous utilisons votre e-mail uniquement pour partager des contenus sur le français. Aucun partage.",
    },
    result: {
      overline: "Votre résultat",
      yourLevel: "Votre niveau",
      score: "Bonnes réponses",
      correctionsTitle: "Corrections commentées",
      correct: "Votre réponse",
      yourAnswer: "Votre réponse",
      correctAnswer: "Bonne réponse",
      explanation: "Explication",
      ctaBook: "Je réserve mon cours offert avec Lionel",
      ctaRetake: "Refaire le test",
      back: "← Retour au site",
    },
  },
};
